import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Access tokens expire after 15 min. Long inventory edits used to fail with a silent
// 401 ("Save failed"). On a 401 (except auth routes), transparently refresh once using
// the 7-day refresh cookie and retry the original request so work is never lost.
let refreshPromise = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const isAuthRoute = original?.url?.includes("/auth/");
    if (status === 401 && original && !original._retry && !isAuthRoute) {
      original._retry = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh");
        await refreshPromise;
        refreshPromise = null;
        return api(original);
      } catch (e) {
        refreshPromise = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function fileUrl(path, w) {
  if (!path) return null;
  const q = w ? `?w=${w}` : "";
  return `${API}/files/${path}${q}`;
}

export function primaryPhoto(boat, w = 800) {
  const photos = boat?.photos || [];
  if (!photos.length) return null;
  const p = photos.find((x) => x.is_primary) || photos[0];
  return fileUrl(p.storage_path, w);
}

export function formatPrice(value) {
  if (value == null) return null;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(value);
}

export const STATUS_LABELS = {
  available: "Available",
  coming_soon: "Coming Soon",
  en_route: "En Route",
  pending: "Pending",
  on_hold: "On Hold",
  sold: "Sold",
  draft: "Draft",
};

export const STATUS_COLORS = {
  available: "bg-mtm-teal text-white",
  coming_soon: "bg-mtm-violet text-white",
  en_route: "bg-mtm-teal-dark text-white",
  pending: "bg-amber-500 text-white",
  on_hold: "bg-slate-500 text-white",
  sold: "bg-red-600 text-white",
  draft: "bg-slate-400 text-white",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
